import React from 'react'
import { useAuth } from '../../contexts/useAuthUser'
import { useEarlyAccessQuery } from '../../requests/billing'
import './styles.css'

export const HeaderUserInfo: React.FC = () => {
  const { authUser } = useAuth()
  const { data: earlyAccessData } = useEarlyAccessQuery(authUser?._id || '', {
    enabled: !!authUser?._id
  })

  const isEarlyAccess = earlyAccessData?.earlyAccess ?? false

  if (!authUser?.email) {
    return null
  }

  return (
    <div className="header-user-info">
      <span className="header-user-email">{authUser.email}</span>
      {isEarlyAccess && !authUser?.superAdmin && (
        <span className="header-early-access-badge">
          EARLY ACCESS
        </span>
      )}
      {authUser?.superAdmin && (
        <span className="header-early-access-badge">
          SUPER ADMIN
        </span>
      )}
    </div>
  )
}
